import type { ReactNode } from "react";

/**
 * Hand-drawn 24-grid stroke icons for the map-editor command palette (ADR 133).
 * The three brush tools share a square glyph differentiated the way the cells
 * read: dashed = unknown, outline = free floor, filled = wall.
 */
const GLYPHS: Record<string, ReactNode> = {
  unknown: <rect x="4" y="4" width="16" height="16" rx="2" strokeDasharray="3 3" />,
  free: <rect x="4" y="4" width="16" height="16" rx="2" />,
  wall: <rect x="4" y="4" width="16" height="16" rx="2" fill="currentColor" stroke="none" />,
  straighten: (
    <>
      <line x1="5" y1="19" x2="19" y2="5" />
      <circle cx="5" cy="19" r="1.7" fill="currentColor" stroke="none" />
      <circle cx="19" cy="5" r="1.7" fill="currentColor" stroke="none" />
    </>
  ),
  crop: (
    <>
      <path d="M6 2v14a2 2 0 0 0 2 2h14" />
      <path d="M2 6h14a2 2 0 0 1 2 2v14" />
    </>
  ),
  simplify: (
    <>
      <path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z" />
      <path d="M18.5 15l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" />
    </>
  ),
  uniform: (
    <>
      <line x1="4" y1="9" x2="20" y2="9" />
      <line x1="4" y1="15" x2="20" y2="15" />
    </>
  ),
  brush: (
    <>
      <path d="M9.1 11.9l8-8a2.8 2.8 0 1 1 4 4l-8 8" />
      <path d="M7 15c-1.7 0-3 1.3-3 3 0 1.3-2.5 1.5-2 2 1 1.1 2.5 2 4 2 2.2 0 4-1.8 4-4a3 3 0 0 0-3-3z" />
    </>
  ),
  undo: (
    <>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h11a5 5 0 0 1 0 10h-1" />
    </>
  ),
  reload: (
    <>
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <circle cx="12" cy="8" r="0.7" fill="currentColor" stroke="none" />
    </>
  ),
};

export function EdIcon({ name }: { name: keyof typeof GLYPHS | string }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true" focusable="false">
      {GLYPHS[name] ?? null}
    </svg>
  );
}
